import { axiosPublic } from '../config';

export const accountVerifyResetPassword = async (data) => {
  try {
    var res = await axiosPublic.post('/OT/AccVeriResetPassword', data)
    return res.data
  } catch (e) {    
    return res
  }
}